// frontend/src/components/cashier/ScreenMirroring.js
import { io } from "socket.io-client";
import { api } from '../../services/api.js';
import { authService } from '../../services/authService.js';
import { Notification } from '../Notification.js';
import { cashierContext } from '../../context/CashierContext.js';
//import { createModal } from '../../utils/domHelpers.js';

let mirroringSocket = null;

export function initializeMirroringSocket(userId) {
    if (!userId) {
        console.error("[Mirroring] No se puede inicializar el socket sin un userId.");
        return;
    }
    if (mirroringSocket && mirroringSocket.connected) {
        mirroringSocket.disconnect();
    }

    const serverUrl = window.location.origin;
    mirroringSocket = io(`${serverUrl}/mirroring`, {
        query: { type: 'cashier', userId: userId },
        // ⭐ LA CURA DEL ERROR 400 EN PM2: Forzar WebSockets directos para evitar el balanceo HTTP
        transports: ['websocket'],
        upgrade: false
    });

    mirroringSocket.on('deviceStatusUpdate', (data) => {
        // En lugar de buscar en un DOM que tal vez no esté abierto, delegamos la lógica de render al Modal si existe
        const modal = document.getElementById('screen-mirroring-modal');
        if (modal && data.status === 'online') {
            const event = new CustomEvent('mirroring-devices-updated', { detail: data.devices });
            modal.dispatchEvent(event);
        }
    });

    mirroringSocket.on('connect', () => {
        console.log('Conectado al servidor de mirroring como cajero.');
        mirroringSocket.emit('getDeviceStatus');
    });

    mirroringSocket.on('connect_error', (err) => {
        console.error('[Mirroring] Error de conexión:', err.message);
    });
}

// Función Modal Principal Multiview
export async function onShowMirroring() {
    if (document.getElementById('screen-mirroring-modal')) return;

    const currentUser = authService.getCurrentUser();
    if (!currentUser || !currentUser.id) return Notification(document.body, "Error: Inicie sesión.", 'error');
    const userId = currentUser.id;

    // Cargar señales de BD
    try {
        const response = await api.get('/signals');
        cashierContext.update({ allSignals: response.signals || response || [] });
    } catch (e) { console.error("Error cargando señales:", e); }

    const state = cashierContext.state;
    const selectedUrls = new Set();
    const MAX_STREAMS = 4;

    const modalContent = document.createElement('div');
    modalContent.className = 'mirroring-modal-content';
    
    // Tus estilos exactos para la cuadrícula Multiview compacta
    const styles = `
    <style>
        .compact-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 8px; padding: 5px; }
        .mini-card { background-color: #064e3b; border: 1px solid #10b981; border-radius: 5px; padding: 6px; cursor: pointer; text-align: center; height: 70px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; transition: all 0.2s; }
        .mini-card:hover { background-color: #047857; transform: scale(1.02); }
        .mini-card.selected { background-color: #D4AF37; border-color: #fff; color: #000 !important; box-shadow: 0 0 8px rgba(212,175,55,0.6); }
        .mini-card.selected * { color: #000 !important; font-weight: bold; }
        .mini-card-title { font-size: 0.75rem; font-weight: bold; color: #D4AF37; margin-bottom: 2px; line-height:1.1; }
        .mini-card-sub { font-size: 0.65rem; color: #a7f3d0; }
        .check-badge { position: absolute; top: -4px; right: -4px; background: #fff; color: #000; border-radius: 50%; width: 16px; height: 16px; font-size: 10px; display: flex; align-items: center; justify-content: center; opacity: 0; transform: scale(0); transition: all 0.2s; }
        .mini-card.selected .check-badge { opacity: 1; transform: scale(1); }
    </style>`;

    modalContent.innerHTML = `
        ${styles}
        <div class="flex justify-between items-center mb-2 border-b border-[#D4AF37] pb-2">
            <h2 class="mirroring-title" style="margin:0; border:none; font-size:1.3rem;">📡 Panel Multiview</h2>
            <span id="selection-counter" style="background:#022c22; color:#D4AF37; padding:2px 8px; border-radius:10px; font-size:0.8rem; border:1px solid #D4AF37;">0 / ${MAX_STREAMS}</span>
        </div>

        <div style="display:grid; grid-template-columns: 2fr 1fr; gap: 15px; height: 400px;">
            <div style="display:flex; flex-direction:column; overflow:hidden;">
                <label style="color:#D4AF37; font-weight:bold; font-size:0.9rem; margin-bottom:5px;">1. Selecciona Transmisión(es):</label>
                <div class="flex gap-2 mb-2">
                    <input type="text" id="manualUrlInput" placeholder="Pegar URL Externa..." style="background:#022c22; border:1px solid #064e3b; color:white; padding:5px; flex-grow:1; border-radius:4px; font-size:0.85rem;">
                    <button id="addManualBtn" style="background:#064e3b; color:#D4AF37; border:1px solid #D4AF37; border-radius:4px; padding:0 8px; cursor:pointer;">➕</button>
                </div>
                <div id="signals-list-container" class="compact-grid" style="flex-grow:1; overflow-y:auto; background:rgba(0,0,0,0.2); border-radius:6px;"></div>
            </div>
            <div style="display:flex; flex-direction:column; border-left:1px solid #064e3b; padding-left:10px;">
                <label style="color:#D4AF37; font-weight:bold; font-size:0.9rem; margin-bottom:5px;">2. Pantallas Destino:</label>
                <div id="devicesListContainer" class="compact-grid" style="flex-grow:1; overflow-y:auto; grid-template-columns: 1fr;">
                    <div style="text-align:center; color:#666; padding:20px;">Buscando...</div>
                </div>
            </div>
        </div>

        <div class="modal-buttons" style="margin-top:10px; padding-top:10px;">
            <button id="closeMirroringBtn" class="cancel-button" style="padding:10px;">Cerrar</button>
            <button id="sendSignalBtn" class="confirm-button opacity-50" style="padding:10px;" disabled>📡 ENVIAR A PANTALLA</button>
        </div>
    `;

    // Usamos el wrapper manual para crear el modal
    const modalOverlay = document.createElement('div');
    modalOverlay.id = 'screen-mirroring-modal';
    modalOverlay.className = 'modal-overlay';
    modalOverlay.appendChild(modalContent);
    document.body.appendChild(modalOverlay);
    setTimeout(() => modalOverlay.classList.add('visible'), 10);

    initializeMirroringSocket(userId);

    const renderSignals = () => {
        const container = modalContent.querySelector('#signals-list-container');
        const items = [];

        if (state.allSignals) {
            state.allSignals.forEach(sig => { items.push({ type: 'signal', name: sig.name, sub: 'Señal Guardada', url: sig.content, id: 'sig-' + sig.id }); });
        }

        state.allRaces.forEach(r => {
            const url = r.stream_url || r.video_url;
            if (url && url.length > 5) {
                const track = state.allTracks.find(t => t.id == r.track_id);
                items.push({ type: 'race', name: track ? track.name : `Carrera ${r.race_number}`, sub: `C-${r.race_number} (${r.status === 'open' ? 'Live' : 'Prog'})`, url: url, id: 'race-' + r.id });
            }
        });

        if (items.length === 0) return container.innerHTML = `<div style="grid-column:1/-1; text-align:center; color:#999; padding:20px;">No hay transmisiones disponibles.</div>`;

        container.innerHTML = items.map(item => {
            const isSelected = selectedUrls.has(item.url);
            return `<div class="mini-card ${isSelected ? 'selected' : ''}" data-url="${item.url}"><div class="check-badge">✓</div><div class="mini-card-title">${item.name}</div><div class="mini-card-sub">${item.sub}</div></div>`;
        }).join('');

        container.querySelectorAll('.mini-card').forEach(card => {
            card.addEventListener('click', () => {
                const url = card.dataset.url;
                if (selectedUrls.has(url)) {
                    selectedUrls.delete(url); card.classList.remove('selected');
                } else {
                    if (selectedUrls.size >= MAX_STREAMS) return Notification(document.body, `Máximo ${MAX_STREAMS} transmisiones.`, 'warning');
                    selectedUrls.add(url); card.classList.add('selected');
                }
                updateUI();
            });
        });
    };
    renderSignals();

    const updateDeviceGrid = (devices) => {
        const container = modalContent.querySelector('#devicesListContainer');
        if (!devices || devices.length === 0) return container.innerHTML = `<div style="text-align:center; color:#666; padding:10px;">Sin conexión.</div>`;
        
        const checkedIds = Array.from(container.querySelectorAll('.mini-card.selected')).map(el => el.dataset.socketId);
        container.innerHTML = devices.map(d => `<div class="mini-card ${checkedIds.includes(d.socketId) ? 'selected' : ''}" data-socket-id="${d.socketId}" style="height:60px;"><div class="check-badge">✓</div><div class="mini-card-title" style="color:white;">${d.deviceName}</div><div class="mini-card-sub" style="color:#4ade80;">● Online</div></div>`).join('');

        container.querySelectorAll('.mini-card').forEach(card => {
            card.addEventListener('click', () => { card.classList.toggle('selected'); updateUI(); });
        });
    };

    // Escuchamos el evento custom que dispara el socket global
    modalOverlay.addEventListener('mirroring-devices-updated', (e) => updateDeviceGrid(e.detail));
    if (mirroringSocket) mirroringSocket.emit('getDeviceStatus');

    function updateUI() {
        const counter = modalContent.querySelector('#selection-counter');
        const btn = modalContent.querySelector('#sendSignalBtn');
        const devicesSelected = modalContent.querySelectorAll('#devicesListContainer .selected').length > 0;
        
        counter.textContent = `${selectedUrls.size} / ${MAX_STREAMS}`;
        if (selectedUrls.size > 0 && devicesSelected) { btn.disabled = false; btn.classList.remove('opacity-50'); }
        else { btn.disabled = true; btn.classList.add('opacity-50'); }
    }

    modalContent.querySelector('#addManualBtn').addEventListener('click', () => {
        const input = modalContent.querySelector('#manualUrlInput');
        const url = input.value.trim();
        if(url) { selectedUrls.add(url); input.value = ''; updateUI(); Notification(document.body, 'URL manual agregada.', 'info'); }
    });

    modalContent.querySelector('#sendSignalBtn').addEventListener('click', () => {
        const targets = Array.from(modalContent.querySelectorAll('#devicesListContainer .selected')).map(el => el.dataset.socketId);
        const signals = Array.from(selectedUrls);

        if (mirroringSocket && mirroringSocket.connected) {
            if (targets.length === 0) return Notification(document.body, `Seleccione al menos una pantalla destino.`, 'error');
            mirroringSocket.emit('sendSignal', { signals, targets }, (ack) => { console.log("Señal enviada"); });
            Notification(document.body, `Enviando ${signals.length} transmisión(es)...`, 'success');
            modalOverlay.classList.remove('visible');
            setTimeout(() => modalOverlay.remove(), 300);
        } else {
            Notification(document.body, `Error: Desconectado del servidor de pantallas.`, 'error');
        }
    });

    modalContent.querySelector('#closeMirroringBtn').addEventListener('click', () => {
        modalOverlay.classList.remove('visible');
        setTimeout(() => modalOverlay.remove(), 300);
    });
}

// ⭐ ELIMINADO: La función createModal se ha movido a utils/domHelpers.js
 /**
  * Crea un modal genérico superpuesto en la página.
  * @param {string} id - ID para el elemento overlay del modal.
  * @param {HTMLElement} contentElement - El elemento HTML que será el contenido del modal.
  * @returns {HTMLElement} El elemento overlay del modal.
  */
 function createModal(id, contentElement) {
     const modalOverlay = document.createElement('div');
    modalOverlay.id = id;
     // Estilos para el overlay
     modalOverlay.style.position = 'fixed';
     modalOverlay.style.top = '0';
     modalOverlay.style.left = '0';
     modalOverlay.style.width = '100%';
     modalOverlay.style.height = '100%';
     modalOverlay.style.backgroundColor = 'rgba(0,0,0,0.6)';
     modalOverlay.style.display = 'flex';
     modalOverlay.style.justifyContent = 'center';
     modalOverlay.style.alignItems = 'center';
     modalOverlay.style.zIndex = '1050';

     modalOverlay.appendChild(contentElement);
     return modalOverlay;
 }